
/*
 * @fileOverView Radio component definition
 */

import Vue from 'vue';
import KeyboardHelper from 'utils/KeyboardHelper'
/**
 * [radio Vue]
 * @type {class}
 */
Vue.component('radio-vue', {
  props: {
    'previousId': {
      type: Number
    },
    'nextId': {
      type: Number
    },
    'isLast': {
      default: false,
      type: Boolean
    }
  },

  methods: {
    /**
     * Handle the selection of radio value
     */
    handleClick() {
      this.$emit('update:radiovalue', this.$refs.radio.value);
    },
    /**
     * [handleTab handles tab events on radio's children.]
     * @param  {event} e [tab event]
     * @return {void}
     */
    handleTab(e) {
      if (KeyboardHelper.isTab(e)) {
        if (!this.isLast) {
          e.preventDefault();
          this.focusRadio(this.nextId)
        }
      }
      else if(KeyboardHelper.isTabBack(e)) {
        e.preventDefault();
        this.$refs.radio.focus();
      }
    },

    /**
     * Handles focusing and checking the next radio as defined in props
     */
    handleForward() {
      this.focusRadio(this.nextId, true);
    },

    /**
     * Handles focusing and checking the previous radio as defined in props
     */
    handleBack() {
      this.focusRadio(this.previousId, true);
    },

    /**
     * Focus and and conditionally check a radio
     * @param {string} id the selector of the radio
     * @param {boolean} isChecked whether to check the radio
     */
    focusRadio(id, isChecked) {
      const selector = `[data-nav-id="${id}"]`;
      //cache the selector so each individual radio is not required to query the DOM repeatedly
      const item = this.$root.domCache.get(selector) || this.$root.domCache.set(selector, document.querySelector(selector));
      if (item) {
        item.focus();
        if (isChecked) {
          item.checked = true;
        }
      }
    }
  }
});
